export const SET_CURRENT_STEP = 'SetCurrentStep';
export const SET_LAST_STEP_VISITED = 'SetLastStepVisited';
export const ADD_DATA_SOURCE = 'AddDataSource';
export const REMOVE_DATA_SOURCE = 'RemoveDataSource';
export const SET_COMPANIES = 'SetCompanies';
export const SET_REPORT_FILTERSETS = 'SetReportFiltersets';
export const SET_REPORT_EDITING_FILTERSETS = 'SetReportEditingFiltersets';
export const UPDATE_FILTERSET_FILTERS = 'UpdateFiltersetFilters';
export const SET_REMOVE_DUPLICATES = 'SetRemoveDuplicates';
export const SET_REPORT_NAME = 'SetReportName';
export const SET_REPORT_FAVORITE = 'SetReportFavorite';
export const UPDATE_FILTERSET_CONJUNCTION = 'UpdateFiltersetConjunction';
export const SET_REPORT_COLUMNS = 'SetReportColumns';
export const UPDATE_COLUMN_FIELD = 'UpdateColumnField';
export const ADD_FILTERSET = 'AddFilterset';
export const REMOVE_FILTERSET = 'RemoveFilterset';
export const COPY_REPORT_FILTERS = 'CopyReportFilters';
export const SAVE_REPORT = 'SaveReport';
export const SET_REPORT_VISIBLE = 'SetReportVisible';
export const SET_CUSTOM_REPORTS = 'SetCustomReports';
export const REMOVE_CUSTOM_REPORTS = 'RemoveCustomReports';
export const SET_REPORT_DETAIL = 'SetReportDetail';
export const SET_MODULES = 'SetModules';
export const SET_DATA_SOURCES = 'SetDataSources';
export const SET_DATA_SOURCE_FIELDS = 'SetDataSourceFields';
export const SET_DATA_SOURCE_FILTERS = 'SetDataSourceFilters';
export const RESET_STATE = 'ResetState';
export const SET_REPORT_HISTORY = 'SetReportHistory';
export const SET_REPORT_DATA_SOURCES = 'SetReportDataSources';
export const ADD_FILTER_DETAIL = 'AddFilterDetail';
export const SET_REPORT_ACCESS = 'SetReportAccess';
export const SET_REPORT_ACCESS_ENTITY = 'SetReportAccessEntity';
export const UPDATE_REPORT_ACCESS = 'accessList';
export const SAVE_REPORT_DETAIL = 'SaveReportDetail';
export const UPDATE_FILTERSETS = 'UpdateFiltersets';
export const UPDATE_EDITING_FILTERSETS = 'UpdateEditingFiltersets';
export const UPDATE_FILTERSETS_ORDER = 'UpdateFiltersetsOrder';
export const UPDATE_FILTERSET_FILTERS_ORDER = 'UpdateFiltersetFiltersOrder';
export const SET_SEARCH_LIST_RESULTS = 'SetSearchListResults';
export const UPDATE_REPORT_ACCESS_PUBLIC = 'UpdateReportAccessPublic';
export const SET_REPORT_STATUS = 'SetReportStatus';
export const SET_REPORT_DATA_SOURCE_ITEMS = 'SetReportDataSourceItems';
export const SET_DOWNLOADED_PRINT_FILE = 'SetDownloadedPrintFile';
export const SET_DOWNLOADED_EXPORT_FILE = 'SetDownloadedExportFile';
export const SET_EDIT_REPORT_ID = 'SetEditReportId';
export const SET_REPORT_ID = 'SetReportId';
export const REMOVE_REPORT_HISTORY = 'RemoveReportHistory';
export const SET_OFFLINE_REPORT_REQUEST = 'SetOfflineReportRequest';
export const CLEAR_OFFLINE_REPORT = 'ClearOfflineReport';
export const SET_BULKEDIT_UPDATE_DATASOURCE_FIELDS =
	'SetBulkEditUpdateSourceFields';
export const UPDATE_SCHEDULED_TASKS_COUNT = 'updateScheduledTasksCount';
export const SET_HAS_SCHEDULED_TASKS = 'setHasScheduledTasks';
